import React from 'react';
import {
    Container,
    CardsContainer,
    CardDeck,
    Card
} from './styles/reviews';

export default function ReviewsSection({children,...restProps}) {
    return <Container {...restProps}>{children}</Container>
}

ReviewsSection.MainContainer = function ReviewsSectionMainContainer ({children, ...restProps}) {
    return <CardsContainer {...restProps}>{children}</CardsContainer>
}

ReviewsSection.ReviewCardDeck = function ReviewsSectionReviewCardDeck({children,...restProps}) {
    return <CardDeck {...restProps}>{children}</CardDeck>
}

ReviewsSection.ReviewCard = function ReviewsSectionReviewCard ({children, ...restProps}) {
    return <Card {...restProps}>{children}</Card>
}